import styled from "styled-components";

export const Container = styled.h4`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  margin: 20px;
`;
